/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteProjectChangeOrderCommand } from '../../models/delete-project-change-order-command';
import { DeleteProjectChangeOrderCommandResult } from '../../models/delete-project-change-order-command-result';

export interface ApiProjectChangeOrderDeleteProjectChangeOrderDelete$Plain$Params {
      body?: DeleteProjectChangeOrderCommand
}

export function apiProjectChangeOrderDeleteProjectChangeOrderDelete$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectChangeOrderDeleteProjectChangeOrderDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectChangeOrderCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectChangeOrderDeleteProjectChangeOrderDelete$Plain.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteProjectChangeOrderCommandResult>;
    })
  );
}

apiProjectChangeOrderDeleteProjectChangeOrderDelete$Plain.PATH = '/api/ProjectChangeOrder/DeleteProjectChangeOrder';
